import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import { ServiceClient } from '../../../../../Services/ServiceClient';

export const updatePostalCode = (country, setAddressState, addressState, postalCode) => {
  if (!postalCode || postalCode.length < 4 || !country?.code) {
    setAddressState({
      ...addressState,
      errors: {
        ...addressState.errors,
        postalCode: postalCode.length === 0 ? '' : formatMessage(Messages.addressInfo_postalCodeWrongFormat),
      },
      address: { ...addressState.address, postalCode: postalCode, city: '' },
    });
    return;
  }

  ServiceClient.searchPostalDistrict(postalCode, country?.code, data => {
    if (data.valid) {
      const wordCapitalizedPostalDistrictName = data.result
        .split(' ')
        .map(w => w.charAt(0).toUpperCase() + w.substr(1).toLowerCase())
        .join(' ');
      setAddressState({
        ...addressState,
        errors: { ...addressState.errors, postalCode: '' },
        address: { ...addressState.address, postalCode: postalCode, city: wordCapitalizedPostalDistrictName },
      });
    } else {
      setAddressState({
        ...addressState,
        errors: { ...addressState.errors, postalCode: formatMessage(Messages.addressInfo_postalCodeIsIncorrect) },
        address: { ...addressState.address, postalCode: postalCode, city: '' },
      });
    }
  });
};
